import React from 'react';

export default class PaginationComponent extends React.Component {
    state = {}

    static getDerivedStateFromProps(nextProps, prevState) {
        let numberOfPages = Math.ceil(nextProps.numberOfElements/nextProps.elementsPerPage)
        return { numberOfPages: numberOfPages }
    }

    renderPages = () => {
        let elements = []
        let lastPage = this.state.numberOfPages - 1;
        if(this.state.numberOfPages > 10) {
            if(this.props.currentPage <=4) {
                for(let i=0; i<=4; i++)
                    elements.push((
                        <li key={i}>
                            <a className={`pagination-link${this.props.currentPage == i ? " is-current" : ""}`}
                                onClick={() => this.props.changePage(i)}
                            >
                                {i+1}
                            </a>
                        </li>
                    ))
                elements.push(
                    <li key={-1}>
                        <span className="pagination-ellipsis">&hellip;</span>
                    </li>
                )
                let i = lastPage;
                elements.push(
                    <li key={i}>
                        <a className={`pagination-link${this.props.currentPage == i ? " is-current" : ""}`}
                            onClick={() => this.props.changePage(i)}
                        >
                            {i+1}
                        </a>
                    </li>
                )
                return elements
            } else if(this.props.currentPage >= lastPage - 3) {
                    elements.push((
                        <li key={0}>
                            <a className={`pagination-link`}
                                onClick={() => this.props.changePage(0)}
                            >
                                {1}
                            </a>
                        </li>
                    ))
                    elements.push(
                        <li key={-1}>
                            <span className="pagination-ellipsis">&hellip;</span>
                        </li>
                    )

                    for(let i=this.props.currentPage; i<=lastPage; i++)
                        elements.push((
                            <li key={i}>
                                <a className={`pagination-link${this.props.currentPage == i ? " is-current" : ""}`}
                                    onClick={() => this.props.changePage(i)}
                                >
                                    {i+1}
                                </a>
                            </li>
                        ))
                    return elements
            } else {
                elements.push((
                    <li key={0}>
                        <a className={`pagination-link`}
                            onClick={() => this.props.changePage(0)}
                        >
                            {1}
                        </a>
                    </li>
                ))
                elements.push(
                    <li key={-1}>
                        <span className="pagination-ellipsis">&hellip;</span>
                    </li>
                )
                elements.push((
                    <li key={this.props.currentPage}>
                        <a className={`pagination-link is-current`}
                            onClick={() => this.props.changePage(this.props.currentPage)}
                        >
                            {this.props.currentPage + 1}
                        </a>
                    </li>
                ))
                elements.push(
                    <li key={-2}>
                        <span className="pagination-ellipsis">&hellip;</span>
                    </li>
                )
                elements.push((
                    <li key={lastPage}>
                        <a className={`pagination-link`}
                            onClick={() => this.props.changePage(lastPage)}
                        >
                            {lastPage + 1}
                        </a>
                    </li>
                ))
                return elements;
            }
        }
        for(let i=0; i<this.state.numberOfPages; i++)
            elements.push((
                <li key={i}>
                    <a className={`pagination-link${this.props.currentPage == i ? " is-current" : ""}`}
                        onClick={() => this.props.changePage(i)}
                    >
                        {i+1}
                    </a>
                </li>
            ))
        return elements;
    }

    render() {
        return (
            <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                <nav  className="pagination is-left">
                    <ul className="pagination-list">
                        {this.renderPages()}
                    </ul>
                </nav>
                <div>
                    <button className="pagination-previous" style={{backgroundColor: "white"}}
                        onClick={() => this.props.changePage(this.props.currentPage - 1)}
                        disabled={this.props.currentPage == 0}>
                        <i className="fas fa-arrow-left"></i>
                    </button>
                    <button className="pagination-next" style={{backgroundColor: "white"}}
                        onClick={() => this.props.changePage(this.props.currentPage + 1)}
                        disabled={this.props.currentPage == (this.state.numberOfPages - 1)}>
                        <i className="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/components/pagination/index.js